// Spinner.tsx
import React from 'react';

const spinnerStyle = {
  display: 'block',
  margin: '0 auto',
  border: '16px solid #f3f3f3',
  borderRadius: '50%',
  borderTop: '16px solid #1C2B74',
  width: '120px',
  height: '120px',
  animation: 'spin 2s linear infinite',
};

const spinnerContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const Spinner: React.FC = () => {
  return (
    <div style={spinnerContainerStyle}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={spinnerStyle}></div>
    </div>
  );
};

export default Spinner;
